import { apiClient } from "@/modules/shared/utils/apiClient";

import { RescheduleSessionRequest } from "../types/RescheduleSessionRequest";

export const rescheduleSessionRequest = ({
  sessionId,
  ...body
}: RescheduleSessionRequest) =>
  apiClient.post(`/coaching-session/${sessionId}/reschedule`, body);
